export var AppState = {
  PageNavigation: 'pageNavigation',
  DataLayer: 'dataLayer',
  EnabledFlippers: 'enabledFlippers',
  Flippers: 'flippers',
  Device: 'device',
  TriggeredPageReady: 'triggeredPageReady',
  HydrateComplete: 'hydrateComplete',
  isBot: 'isBot',
  NavigationState: 'navigationState',
  PageId: 'pageId'
};
export var NavigationState = {
  Complete: 'complete',
  Pending: 'pending'
};
export var AppStateEvent = {
  Change: function Change(type) {
    return "".concat(type, "Change");
  }
};
export var PARTY_TOWN_GLOBAL_FLIPPER_NAME = 'global-tps-proxy';
export var IPV6_EXPANDED_GROUP_COUNT = 8;
export var IPV6_EXPANDED_SUB_GROUP_COUNT = 4;
export var LocalStorageChangeEvent = 'LocalStorageChange';
export var APOLLO_ERROR_TYPES = {
  nonBreaking: 'NON_BREAKING_ERROR',
  redirecting: 'REDIRECTING_ERROR',
  breaking: 'BREAKING_ERROR'
};
export var KBB_BRAND = 'KBB';
export var SAVE_ELOT_PATH = {
  base: '/auth-user/saved-listings',
  byBookmarkId: '/auth-user/saved-listing/id',
  subscribeEmail: '/light-user/price-drop'
};